import { dictionaryCRUD } from "../../../actions/dictionary"
import { selector } from "../../../api"
import * as Yup from 'yup'
import { useFormik } from 'formik'
import { useEffect, useState } from "react"
import { toast } from "react-toastify"
import { useParams, useNavigate } from "react-router-dom";

const dictionarySchema = Yup.object().shape({
  id: Yup.string().required('Dictionary ID is required'),
  dictionary_name_en: Yup.string().required('English name is required'),
  dictionary_name_sw: Yup.string().required('Swahili name is required'),
})

export const EditDictionary = (props) => {

  const user = selector.User()
  const [loading, setLoading] = useState(false)

  const navigate = useNavigate();
  const param = useParams();
  useEffect(() => {
    setLoading(true)
    setTimeout(() => {
      dictionaryCRUD.loadDictionaryById(param.id).then((resp) => {
        // console.log(resp.data);
        formik.setFieldValue("id", resp.data ? resp.data.id : '');
        formik.setFieldValue("dictionary_code", resp.data ? resp.data.dictionary_code : '');
        formik.setFieldValue("dictionary_name_en", resp.data ? resp.data.dictionary_name_en : '');
        formik.setFieldValue("dictionary_name_sw", resp.data ? resp.data.dictionary_name_sw : '');
      }).finally(() => {
        setLoading(false)
      })
    }, 2000)

  }, [])
  const formik = useFormik({
    initialValues: {
      id: param.id,
      dictionary_code: '',
      dictionary_name_en: '',
      dictionary_name_sw: ''
    },
    validationSchema: dictionarySchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      const { id, dictionary_code, dictionary_name_en, dictionary_name_sw } = values
      const recorded_by = user.id
      const data = { id, dictionary_code, dictionary_name_en, dictionary_name_sw, recorded_by }
      setLoading(true)
      setTimeout(() => {
        dictionaryCRUD.updateDictionary(param.id,data).then(() => {
          toast.success('Dictionary changes have been saved.', { autoClose: 7000 })
        }).catch((error) => {
          toast.error(error, { autoClose: 7000 })
        }).finally(() => {
          navigate("/dictionary");
          setLoading(false)
        })
      }, 2000)

    }
  })

  return (
    <>
      <div class="main-content">
        <div class="page-content">
          <div class="container-fluid">

            <div class="row">
              <div class="col-12">
                <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 class="mb-sm-0">Dictionary</h4>

                  <div class="page-title-right">
                    <ol class="breadcrumb m-0">
                      <li class="breadcrumb-item"><a href="#">Dictionary</a></li>
                      <li class="breadcrumb-item active">List</li>
                    </ol>
                  </div>

                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-12">
                <form onSubmit={formik.handleSubmit}>
                  <div class="card">
                    <div class="card-header">
                      <h6 class="card-title mb-0">Edit Dictionary</h6>
                    </div>
                    <div class="card-body">
                      <div className="row">
                          <input hidden type="text" {...formik.getFieldProps('id')} class="form-control" />
                        <div className="col-md-4 col-sm-12">
                          <div class="mb-3">
                            <label for="lastNameinput" class="form-label">Dictionary Code</label>
                            <input type="text" class="form-control" {...formik.getFieldProps('dictionary_code')} placeholder="Dictionary code" />
                          </div>
                        </div>
                        <div className="col-md-4 col-sm-12">
                          <div class="mb-3">
                            <label for="lastNameinput" class="form-label">Dictionary English Name <span className="text-danger">*</span></label>
                            <input type="text" class="form-control" {...formik.getFieldProps('dictionary_name_en')} placeholder="English Name" />
                            {formik.touched.dictionary_name_en && formik.errors.dictionary_name_en && (
                              <div className='fw-light h6 mt-1' style={{ fontSize: '15px' }}>
                                <span role='alert' className='text-danger'>{formik.errors.dictionary_name_en}</span>
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="col-md-4 col-sm-12">
                          <div class="mb-3">
                            <label for="lastNameinput" class="form-label">Dictionary Swahili Name <span className="text-danger">*</span></label>
                            <input type="text" class="form-control" {...formik.getFieldProps('dictionary_name_sw')} placeholder="Swahili Name" />
                            {formik.touched.dictionary_name_sw && formik.errors.dictionary_name_sw && (
                              <div className='fw-light h6 mt-1' style={{ fontSize: '15px' }}>
                                <span role='alert' className='text-danger'>{formik.errors.dictionary_name_sw}</span>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="card-footer">
                      <a href="javascript:void(0);" class="btn btn-outline-danger fw-medium" data-bs-dismiss="modal"><i class="ri-close-line me-1 align-middle"></i> Close</a>
                      <button type='submit' className="btn btn-success w-50 theme-btn" disabled={formik.isSubmitting || !formik.isValid}>
                        {!loading && <span className='indicator-label'><i className="las la-save la-lg"></i>save </span>}
                        {loading && (
                          <span className='indicator-progress' style={{ display: 'block' }}>
                            Please wait...
                            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                          </span>
                        )}
                      </button>
                    </div>
                  </div>
                </form>

              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )

}